import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { FEATURE_SOURCE_TYPE_OPTIONS } from "@dndModels/Constants";

import CommonUtilities from "@utilities/common_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBox";
import { DataType } from '@dndModels/Types';

interface Props {
  name?: string;
  type?: DataType | "Attached" | "";
  id?: string;
  types?: (DataType | "Attached" | "")[];
  ids?: string[];
  extra_options?: string[];
  onChange: (changed: { type?: string, id?: string, types?: string[], ids?: string[] }) => void; 
  disabled?: boolean;
  log_it?: boolean;
}

const common_util = CommonUtilities.getInstance();

export default function SelectSourceBox({
  name = "",
  type,
  id,
  types,
  ids,
  extra_options = [],
  onChange,
  disabled = false,
  log_it = false,
}: Props) {
  const [use_type, setUseType] = useState(type);
  const [use_id, setUseId] = useState(id);
  const [use_types, setUseTypes] = useState(types);
  const [use_ids, setUseIds] = useState(ids);
  const [source_type_changing, setSourceTypeChanging] = useState(false);

  useEffect(() => {
    if (source_type_changing) {
      setSourceTypeChanging(false);
    }
  }, [source_type_changing, setSourceTypeChanging]);

  useEffect(() => {
    if (use_type !== type || use_types !== types) {
      setUseId("");
      setSourceTypeChanging(true);
      if (extra_options.length > 0) {
        if (use_type) {
          if (extra_options.includes(use_type)) {
            onChange({ type: use_type, id: use_id });
          }
        } else if (use_types) {
          if (common_util.anyOverlaps(extra_options, use_types)) {
            onChange({ types: use_types, ids: use_ids });
          }
        }
      }
    }
    // eslint-disable-next-line
  }, [use_type, use_types, setSourceTypeChanging]);

  useEffect(() => {
    if (use_type !== undefined && type !== undefined && use_id !== undefined && id !== undefined) {
      if (use_type !== "" && use_id !== "" && (use_type !== type || use_id !== id)) {
        // debugger;
        onChange({ type: use_type, id: use_id });
      }
    }
    // eslint-disable-next-line
  }, [use_id, onChange]);

  useEffect(() => {
    if (use_types !== undefined && types !== undefined && use_ids !== undefined && ids !== undefined) {
      if (use_types.length > 0 && use_ids.length > 0 && (!common_util.listsMatch(use_types, types) || !common_util.listsMatch(use_ids, ids))) {
        // debugger;
        onChange({ types: use_types, ids: use_ids });
      }
    }
    // eslint-disable-next-line
  }, [use_id, onChange]);

  return (
    <Grid container spacing={0} direction="row">
      { name !== "" && <Grid
        className="header"
        size={{
          xs: 12
        }}>{ name }</Grid> }
      <Grid
        size={{
          xs: 6
        }}>
        { use_types ?
          <SelectStringBox
            name="Source Types"
            values={use_types}
            options={FEATURE_SOURCE_TYPE_OPTIONS}
            extra_options={extra_options}
            disabled={disabled}
            multiple
            onChange={setUseTypes}
          />
        : use_type !== undefined &&
          <SelectStringBox
            name="Source Type"
            value={`${use_type}`}
            options={FEATURE_SOURCE_TYPE_OPTIONS}
            extra_options={extra_options}
            disabled={disabled}
            onChange={setUseType}
          />
        }
      </Grid>
      { !source_type_changing && 
        <>
          <Grid size={6}>
            { use_types !== undefined && use_ids !== undefined && use_types.filter(o => !extra_options.includes(o)).length > 0 ?
              <SelectObjectBox
                name="Sources"
                data_types={use_types.filter(o => !extra_options.includes(o))}
                values={use_ids}
                disabled={disabled}
                auto_sort
                multiple
                dominant_only
                onChange={(changed: string[]) => {
                  setUseIds(changed);
                }}
              />
            : use_type !== undefined && use_type !== "" &&
              <SelectObjectBox
                name="Source"
                data_type={use_type}
                value={use_id}
                disabled={disabled}
                auto_sort
                dominant_only
                onChange={(changed: string) => {
                  setUseId(changed);
                }}
              />
            }
          </Grid>
        </>
      }
    </Grid>
  );
}
